import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EventCat.css";
import coroprateimg from "../../images/Event_Cateogry/corporateevent.png";
import weddimg from "../../images/Event_Cateogry/wedd event.png";
import haldiimg from "../../images/Event_Cateogry/haldi event.png";
import wedding from "../../images/Event_Cateogry/wedding event.png";
import firstnight from "../../images/Event_Cateogry/first night.jpeg";
import concertimg from "../../images/Event_Cateogry/concert.jpeg";
import cockatailimg from "../../images/Event_Cateogry/cocktail.jpeg";
import surpriseimg from "../../images/Event_Cateogry/surprise event.jpeg";
import birthdayimg from "../../images/Event_Cateogry/birthday.jpg";

function EventCat() {
  const slider = React.useRef(null);

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1020,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 725,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="container event_container">
      <p style={{ color: "white" }} className="container_heading">
        <span className="heading_first">Event</span> Categories
      </p>

      <div className="eventcat_cards">
        <Slider ref={slider} {...settings}>
          <div className="eventcat_card">
            <img src={weddimg} className="eventcat_card_image" />
            <p className="eventcat_card_text">Destination Wedding</p>
          </div>

          <div className="eventcat_card">
            <img src={coroprateimg} className="eventcat_card_image" />
            <p className="eventcat_card_text">Corporate Event</p>
          </div>

          <div className="eventcat_card">
            <img src={haldiimg} className="eventcat_card_image" />
            <p className="eventcat_card_text">Haldi, Mehndi</p>
          </div>

          <div className="eventcat_card">
            <img src={wedding} className="eventcat_card_image" />
            <p className="eventcat_card_text">Wedding</p>
          </div>

          <div className="eventcat_card">
            <img src={birthdayimg} className="eventcat_card_image" />
            <p className="eventcat_card_text">Birthday Parties</p>
          </div>

          <div className="eventcat_card">
            <img src={surpriseimg} className="eventcat_card_image" />
            <p className="eventcat_card_text">Surprise Parties</p>
          </div>

          <div className="eventcat_card">
            <img src={cockatailimg} className="eventcat_card_image" />
            <p className="eventcat_card_text">Cocktail/Bachelor Party</p>
          </div>

          <div className="eventcat_card">
            <img src={concertimg} className="eventcat_card_image" />
            <p className="eventcat_card_text">Concerts</p>
          </div>

          <div className="eventcat_card">
            <img src={firstnight} className="eventcat_card_image" />
            <p className="eventcat_card_text">First Night Decor</p>
          </div>
        </Slider>
      </div>

      <div className="eventcat_arrows">
        <button onClick={() => slider?.current?.slickPrev()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="eventcat_left_arrow"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button onClick={() => slider?.current?.slickNext()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="eventcat_right_arrow"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default EventCat;
